import React from 'react'
import PropTypes from 'prop-types'
import './style.css'
import Truncate from "../../../_common/Truncate"
import PlayCourse from "../../../_common/_icons/PlayCourse"
import ArrowClick from "../../../_common/_icons/ArrowClick"
import CalendarDate from "../../../_common/_icons/CalendarDate"
import ProgressBar from '../../ProgressBar'
import moment from '../../../../../src/helpers/moment';

const MCEadCourse = (props) => {

    const {
        title,
        progress,
       // code,
        startDate,
        endDate,
        imgSrc,
        active,
        type
    } = props


    const courseAlreadyStarted = progress > 0 || !startDate || moment().diff(startDate) > 0

    return (
        <div className='mc-ead-course'>

            {
                !active &&
                <div className='inactive-container'>
                    <div className='i-overlay'/>
                    <div className="content-overlay">
                        <ArrowClick />
                        <span>Falta pouco para concluir a inscrição</span>
                    </div>
                </div>
            }

            <div className={'image-wrapper'}>

                <div className={'image'}
                    style={{

                        backgroundImage: `url('${imgSrc}')`
                    }}
                />

                {
                    active &&
                    <div className={'overlay'}>
                        {
                            !!type &&
                            <div className='type'>{type}</div>
                        }
                        {
                            type === 'Online' && <PlayCourse width={50} />
                        }


                        {
                            courseAlreadyStarted && type === 'Online' ?
                                (
                                    <div className={'progress'}>
                                        <div className="text-progress">
                                            <span>{progress ? progress.toFixed(2) : 0}%</span><span>Conclusão</span>
                                        </div>
                                        <ProgressBar porcentage={progress} />
                                    </div>
                                )
                                : (
                                    <div className={'progress'}>
                                        <div className="initial-days">
                                            <CalendarDate height={35} />
                                            <span>Início: {moment(startDate).fromNow()}</span>
                                            <span>Término: {moment(endDate).fromNow()}</span>
                                        </div>
                                    </div>
                                )
                        }
                    </div>
                }

            </div>

            <div className={'description'}>
                <h3>
                    <Truncate text={title}

                              maxLength={100}

                    />
                </h3>
            </div>
        </div>
    )
}

MCEadCourse.propTypes = {
    imgSrc: PropTypes.string,
    title: PropTypes.string.isRequired,
    progress: PropTypes.number,
    code: PropTypes.string,
    startDate: PropTypes.number,
    active: PropTypes.bool
}

MCEadCourse.defaultProps = {}

export default MCEadCourse



// WEBPACK FOOTER //
// ./src/components/_ead/_courseList/Course/index.js